import { Component, Input } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { IHyperlink } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-hyperlink-item',
    templateUrl: './admin-hyperlink-item.component.html',
    styleUrls: ['./admin-hyperlink-item.component.scss'],
    standalone: false
})
export class AdminHyperlinkItemComponent extends AdminActionsDirective {
    @Input() index: number;
    @Input() item: IHyperlink;

    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
